import React from 'react';
import { testimonials } from '../mock';

const featured = testimonials.filter((item) =>
  ['Little Devils Wood Fire Pizza', 'Astranova Jewellery'].includes(item.company)
);

const Results = () => (
  <div className="mx-auto mt-12 max-w-4xl border-y border-white/10 py-12 md:mt-16 md:py-14">
      <div className="mx-auto max-w-2xl text-center px-4">
        <p className="font-display text-sm uppercase tracking-[0.35em] text-[#c9a85f]">Client outcomes</p>
        <h4 className="mt-4 font-display text-3xl font-bold uppercase text-white md:text-4xl">Stories built to keep working</h4>
      </div>
      <div className="mt-9 grid gap-6 md:grid-cols-2">
        {featured.map((item) => (
          <figure key={item.company} className="rounded-2xl border border-white/10 bg-[#111] p-7 md:p-9">
            <blockquote className="text-lg leading-relaxed text-white/85">“{item.quote}”</blockquote>
            <figcaption className="mt-6">
              <span className="block font-display font-semibold text-[#c9a85f]">{item.name}</span>
              <span className="text-sm text-white/50">{item.role}, {item.company}</span>
            </figcaption>
          </figure>
        ))}
      </div>
  </div>
);

export default Results;
